import * as type from '../types';

const initialState = {
    menuList: [],
    menuLoading: false,
    menuError: false,
    list: [],
    loading: false,
    error: false,
    activePage: 0,
    totalPageCount: 0,
    settings: {
        data: {},
        settingsLoading: false,
        settingsError: false
    }
}

const notification = (state = initialState, action) => {
    switch(action.type){
        case type.GET_NOTIFICATION_SETTINGS_REQUEST:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    settingsLoading: true,
                    settingsError: false
                }
            }
        case type.GET_NOTIFICATION_SETTINGS_SUCCEEDED:
            return {
                ...state,
                settings: {
                    data: action.payload,
                    settingsLoading: false,
                    settingsError: false
                }
            }
        case type.GET_NOTIFICATION_SETTINGS_FAILED:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    settingsLoading: false,
                    settingsError: true
                }
            }
        case type.GET_MENU_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                menuLoading: true,
                menuError: false
            }
        case type.GET_MENU_NOTIFICATIONS_SUCCEEDED:
            return {
                ...state,
                menuList: action.payload,
                menuLoading: false,
                menuError: false
            }
        case type.GET_MENU_NOTIFICATIONS_FAILED:
            return {
                ...state,
                menuLoading: false,
                menuError: true
            }
        case type.GET_NOTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            }
        case type.GET_NOTIFICATIONS_SUCCEEDED:
            return {
                ...state,
                list: action.payload.items,
                activePage: action.payload.activePage,
                totalPageCount: action.payload.totalPageCount,
                loading: false,
                error: false
            }
        case type.GET_NOTIFICATIONS_FAILED:
            return {
                ...state,
                loading: false,
                error: true
            }
        default:
            return state;
    }
}

export default notification;